import React, { Component } from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import './index.scss';

class SessionTimeoutError extends Component {
  static mixins = [PureRenderMixin];

  static propTypes = {
    intl: PropTypes.object.isRequired,
  };

  static defaultProps = {
    title: 'Session Expired',
    secondaryMessage: 'Please log in again.',
  };

  buttonClick = () => {
    window.location.reload();
  };

  renderButton = () => {
    return (
      <div className="GlobalError-ButtonContainer">
        <a onClick={this.buttonClick} className="ui button session-timeout">
          Okay
        </a>
      </div>
    );
  };

  getMessage = () => {
    const { intl, timeoutMinutes } = this.props;
    let min_text = 'minute';
    if (parseInt(timeoutMinutes) > 1) {
      min_text = 'minutes';
    }

    return `${intl.formatMessage(
      {
        id: 'SESSION_EXPIRY_TEXT',
        defaultMessage:
          'You have been logged out after {timeoutMinutes} {minText} of inactivity.',
      },
      {
        timeoutMinutes,
        minText: min_text,
      }
    )}`;
  };

  render() {
    return (
      <div className="GlobalError-Container SessionTimeoutError">
        <div className="GlobalError-Message">
          <h1>
            <span className="text">{this.props.title}</span>
          </h1>
          <p>{this.getMessage()}</p>
          <p>{this.props.secondaryMessage}</p>
        </div>
        {this.renderButton()}
      </div>
    );
  }
}

export default injectIntl(SessionTimeoutError);
